module.exports = __webpack_public_path__ + "4015e9137d9a60565fd90561d274f7d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-gold-s.png
// module id = 2357
// module chunks = 0